import { Routes } from '@angular/router';

// Die Parent-Route für das Kundenprofil
export const CUSTOMER_PROFILE_BASE_ROUTE = 'customer-profile-show';
// Die Child-Routen für das Kundenprofil
export const CUSTOMER_PROFILE_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/customer-profile-show/customer-profile-page.component')
  },
];


// Die Parent-Route für die Kundenkontakte
export const CUSTOMER_CONTACTS_BASE_ROUTE = 'customer-contact-list';
// Die Child-Routen für die Kundenkontakte
export const CUSTOMER_CONTACTS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/customer-contact-list/customer-contacts.page.component')
  },
  {
    path: 'details/:id',
    loadComponent: () => import('app/domain/customer-masterdata/features/customer-contact-create-update/customer-contact-details-page.component')
  }
];

